module.exports = __webpack_public_path__ + "img/lg_ring_y_o_1_1@3x.1f105518.png";